import { useRef } from 'react'
import createActions from './createActions'

export default function useActions() {
  const actions = useRef(createActions())

  return actions.current
}
